import validate from "/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/.c12/gitlab_ikamai_nuxt_zrArIKnFUe/middleware/auth.ts")
}